










import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class PlayButton extends Vue {
    public onClicked(event) {
        this.$emit('click', event);
    }
}
